import ezyLogo from "../assets/ezy-logo.webp";

export function Logo({ height = 36 }) {
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img
        src={ezyLogo}
        alt="Ezy Access Solutions"
        style={{ height: `${height}px`, width: "auto", display: "block" }}
      />
    </div>
  );
}
